import { TYPES, assetContainer } from '@desygner/ui-editor-data-access-assets';

import { TYPES as ApiGatewayTypes } from '@desygner/ui-core-api-gateway';
import { Uploader } from '@desygner/ui-common-uploader';

export async function uploadAsset (blob, name, mimeType, assetType) {
  return new Promise((resolve, reject) => {
    const uploader = new Uploader(assetType, {
      companionUrl: INKIVE.C.uppy_companion_url,
      restrictions: {
        allowedFileTypes: ['image/png', 'image/jpeg', 'image/svg+xml']
      },
      onFileUploaded: (data, response) => {
        resolve({
          data,
          url: decodeURIComponent(response.uploadURL)
        });
      },
      bucket: INKIVE.C.BUCKET,
      objectKey: `virginia/company/${assetType}/original/`
    });

    try {
      return uploader.uploadImage(blob, name, mimeType);
    } catch (e) {
      reject(e);
    }
  });
}

export async function addAssetToLibrary (url, name, height, width, assetType) {
  assetContainer
    .get(ApiGatewayTypes.ApiGateway)
    .configure(INKIVE.C.API_URL, CONFIG.credentials.api_key, CONFIG.company_id);

  const serviceAPI = assetContainer.get(TYPES.UserAssets);

  const payload = {
    company_id: CONFIG.company_id,
    type: capitalizeFirstChar(assetType),
    data: {
      source: url,
      name,
      dimensions: { height, width }
    }
  };

  const response = await serviceAPI.addAsset(assetType + 's', payload);

  INKIVE.EditorFacade.trigger('assets.added', [
    {
      id: response.id,
      name: response.data.name,
      source: response.data.source,
      details: response
    }
  ]);

  return url;
}

function capitalizeFirstChar (str) {
  if (!str) return str;

  return str.charAt(0).toUpperCase() + str.slice(1);
}
